import React from 'react';
export function PaymentBadges() {
  return <div className="flex flex-wrap justify-center gap-2 mt-4" data-id="element-175">
      {/* Visa */}
      <div className="flex items-center justify-center bg-[#1a1f71] text-white text-xs font-bold px-3 py-1.5 rounded w-14 h-8" data-id="element-176">
        VISA
      </div>
      {/* Mastercard */}
      <div className="flex items-center justify-center bg-white border border-gray-200 px-2 py-1.5 rounded w-14 h-8 relative overflow-hidden" data-id="element-177">
        <div className="w-4 h-4 rounded-full bg-[#eb001b] absolute left-2 opacity-90 mix-blend-multiply" data-id="element-178"></div>
        <div className="w-4 h-4 rounded-full bg-[#f79e1b] absolute right-2 opacity-90 mix-blend-multiply" data-id="element-179"></div>
      </div>
      {/* PayPal */}
      <div className="flex items-center justify-center bg-[#003087] text-white text-xs font-bold italic px-2 py-1.5 rounded w-16 h-8" data-id="element-180">
        PayPal
      </div>
      {/* Amex */}
      <div className="flex items-center justify-center bg-[#2e77bc] text-white text-[10px] font-bold px-2 py-1.5 rounded w-14 h-8 text-center leading-tight" data-id="element-181">
        AMEX
      </div>
      {/* Apple Pay */}
      <div className="flex items-center justify-center bg-black text-white text-xs font-semibold px-2 py-1.5 rounded w-16 h-8" data-id="element-182">
        Pay
      </div>
    </div>;
}